
import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'

interface LocationModalProps {
  isOpen: boolean
  onClose: () => void
  location: {
    name: string
    imageUrl: string
    year: number
  } | null
}

export const LocationModal: React.FC<LocationModalProps> = ({ isOpen, onClose, location }) => {
  if (!location) return null

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90"
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", damping: 20, stiffness: 300 }}
            className="relative max-w-4xl max-h-[90vh] bg-white border-8 border-white overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* 关闭按钮 */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 z-10 bg-black text-white w-12 h-12 flex items-center justify-center text-2xl font-bold hover:bg-white hover:text-black border-4 border-black transition-none"
            >
              ×
            </button>
            
            {/* 图片 */}
            <div className="relative">
              <img
                src={location.imageUrl}
                alt={location.name}
                className="w-full h-auto max-h-[70vh] object-contain"
              />
            </div>
            
            {/* 地点信息 */}
            <div className="p-8 bg-white border-t-4 border-black">
              <h3 className="text-4xl font-black text-center">{location.name}</h3>
              <div className="text-xl text-center text-gray-600 mt-2">{location.year}</div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
